import React from 'react';
import styled from 'styled-components';

import logo from '../assets/img/inplayer-logo.svg';

import LanguagePicker from './LanguagePicker';
import ButtonSpan from './common/ButtonSpan';

const RestyledButtonSpan = styled(ButtonSpan)`
  display: block !important;
`;

const HiddenForLarge = styled.span`
  @media only screen and (min-width: 600px) {
    display: none;
  }
`;

const HiddenForMobile = styled.span`
  @media only screen and (max-width: 600px) {
    display: none;
  }
`;

const StyledLi = styled.li`
  text-transform: none;
  display: inline-block;
`;

const Menu = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 0.8em;
  text-transform: uppercase;
  font-weight: 400;
`;

const Link = styled.a`
  padding: 10px;
  display: block;
  color: #888;
  font-weight: 100;
  text-decoration: none;
  transition: all ease-in 0.15s;
  cursor: pointer;

  :hover {
    color: #333;
  }
`;

const AppLogo = styled.img`
  width: 66.66px;
  height: 20px;
  opacity: 0.7;
  transition: all ease-in 0.15s;

  @media only screen and (max-width: 600px) {
    width: 116.66px;
    height: 35px;
    margin-bottom: -5px;
  }
`;

const CustomAppLogo = styled.img`
  width: auto;
  height: 51px;
  margin: -10px 0;

  @media only screen and (max-width: 600px) {
    height: 35px;
  }
`;

const StyledHeader = styled.header`
  padding: 15px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 10;
  background: #fff;

  :hover ${AppLogo} {
    opacity: 1;
  }
`;

const HiddenOnExtraSmall = styled.a`
  @media only screen and (max-width: 445px) {
    display: none;
  }
`;

const Header = ({
  branding: {
    paywall_brand_logo: brandLogo,
    paywall_buttons_bg_color: bgColor,
    paywall_buttons_text_color: textColor,
  },
  mediaspace,
  mediaspaceUrl,
  isAuthenticated,
  languages: { language, setLanguage, translate },
}) => {
  const brandingStyles = {
    background: bgColor,
    color: textColor,
  };

  const standaloneButtonClass = `inplayer-paywall-${
    isAuthenticated ? 'logout' : 'login'
  }`;

  return (
    <StyledHeader>
      <HiddenOnExtraSmall href={window.location.href}>
        {brandLogo ? (
          <CustomAppLogo src={brandLogo} alt="InPlayer" />
        ) : (
          <AppLogo src={logo} alt="InPlayer" />
        )}
      </HiddenOnExtraSmall>
      <Menu>
        <StyledLi>
          <Link href={mediaspace}>
            {`${translate('go_to')} `}
            <HiddenForMobile>
              <strong>{mediaspaceUrl || ' Mediaspace'}</strong>
            </HiddenForMobile>
            <HiddenForLarge> Mediaspace</HiddenForLarge>
          </Link>
        </StyledLi>
        <StyledLi>
          <RestyledButtonSpan
            {...brandingStyles}
            className={standaloneButtonClass}
            id={standaloneButtonClass}
          >
            {translate(isAuthenticated ? 'logout' : 'login_signup')}
          </RestyledButtonSpan>
        </StyledLi>
        <StyledLi>
          <LanguagePicker
            language={language}
            setLanguage={setLanguage}
            translate={translate}
          />
        </StyledLi>
      </Menu>
    </StyledHeader>
  );
};

export default Header;
